export default "__VITE_ASSET__WOv2CxQg__"